module.exports = __webpack_public_path__ + "static/media/YM06_1.99f6b444.jpg";